import { Controller } from "@hotwired/stimulus"

// Scrollspy du sommaire éditorial : surligne (.active) le lien du sommaire
// correspondant à la section actuellement visible. Porté du <script> de la
// maquette #929 (IntersectionObserver), encapsulé dans un contrôleur Stimulus.
export default class extends Controller {
  static targets = ["link"]
  // Hauteur occultée en haut de fenêtre (bandeaux + nav, plus tout rail sticky
  // propre à la page). Le défaut 92 vaut pour les pages article ; la page
  // Ressources, qui empile un rail de chapitres sous la nav, passe sa propre
  // valeur — sinon elle nomme comme « courant » un chapitre encore caché
  // derrière ce rail.
  static values = { topOffset: { type: Number, default: 92 } }

  connect() {
    if (!("IntersectionObserver" in window)) return

    // Associe chaque lien #id à son heading/section cible.
    this.map = this.linkTargets
      .map((link) => {
        const id = (link.getAttribute("href") || "").slice(1)
        const el = id ? document.getElementById(id) : null
        return { link, el }
      })
      .filter((entry) => entry.el)

    if (!this.map.length) return

    this.observer = new IntersectionObserver(
      (entries) => this.onIntersect(entries),
      { rootMargin: `-${this.topOffsetValue}px 0px -70% 0px` }
    )
    this.map.forEach((entry) => this.observer.observe(entry.el))
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return
      this.map.forEach((m) => m.link.classList.toggle("active", m.el === entry.target))
    })
  }
}
